import { createSDK } from '../../../sdk';

export const getSdk = (projectId: string) => createSDK({ projectId });
